import { ID } from '@ianesthesie-kit/services';
import { doctorBffApi } from '../doctorBffApi.slice';
import { wrapError } from '../error';
import { PaymentLink } from './paymentLink.model';
import { PaymentLinkService } from './paymentLink.service';

export const paymentLinkApi = doctorBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    /**
     * Minting a link touches nothing but `line.paymentLink`: it records no trail event, sends
     * nothing and moves no amount — so only the two caches carrying the line itself go stale.
     */
    createPaymentLink: builder.mutation<PaymentLink, { lineId: ID }>({
      invalidatesTags: (res, err) =>
        err ? [] : ['BillingLines', 'BillingDashboard'],
      queryFn: ({ lineId }) =>
        PaymentLinkService.create(lineId)
          .then((data) => ({ data }))
          .catch(wrapError)
    })
  })
});

export const { useCreatePaymentLinkMutation } = paymentLinkApi;
